var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_ptrn_add.0bc04a25.png","uri@2x": __webpack_public_path__ + "static/media/img_ptrn_add.f4a3ed8b.png","uri@3x": __webpack_public_path__ + "static/media/img_ptrn_add.910c0425.png",
    width: 12,
    height: 4
});